import axios from 'axios'
import $store from '@/store/index'
import Api from '@/util/api'
import Apis from '@/util/apis'
import util from '@/util/util'

// axios.defaults.withCredentials = true

// const api = axios.create({
// baseURL: "https://api.binance.com/api/v1/",
// baseURL: 'https://titan.capico.app:2505/'
// baseURL: process.env.VUE_APP_BASE_URL
// headers: {
//   'Content-Type': 'application/json'
// }
// })

const ftxApi = axios.create({
  baseURL: 'https://ftx.com/api'
})

const history = {}

const checkUndefinedData = (symbolInfo) => {
  const symbolData = symbolInfo.toLowerCase().split(/:|\//)

  return symbolData.includes('undefined')
}

// const LastBar = {}
// const BotLastBar = {}

export default {
  history,
  lastBar: {},
  botLastBar: {},
  gridLastBar: {},
  lastBarBySymbol: {},

  getBars: function (bartype, symbolInfo, resolution, from, to, first, limit, count) {
    const symbSplit = symbolInfo.full_name.replace('/', '').split(':')
    let symbol = symbSplit[1]
    // console.log('get bars:', symbolInfo.name, symbolInfo.full_name, resolution, from, to, symbol)
    let eid = symbSplit[0].substr(0, 3)
    if (eid === 'FUT') {
      eid = 'BIF'
    }
    if (symbSplit[0] === 'BYBIT FUTURES') {
      eid = 'BYF'
    }
    if (symbSplit[0] === 'BITGET SPOT') {
      eid = 'GET'
    }
    if (symbSplit[0] === 'BITGET FUTURES') {
      eid = 'GEF'
    }
    if (eid === 'FTX') {
      symbol = symbolInfo.name
      from = from / 1000
      to = to / 1000
      if (symbol.includes('-')) {
        symbol = symbol.replace('/USD', '')
      }
    }
    if (eid === 'OKX') {
      symbol = symbolInfo.name.replace('/', '_')
    }
    if (eid === 'BYB' || eid === 'BYF') {
      from = from / 1000
      to = to / 1000
    }
    let symb12 = symbol.replace('/', '_')
    if (symb12.includes('-')) {
      symb12 = symb12 + '_USD'
    }

    if (checkUndefinedData(symbolInfo.full_name)) {
      console.log('ERR: wrong symbolInfo:', JSON.stringify(symbolInfo))
      return new Promise((resolve) => { resolve([]) })
    }

    // to support new klines service in germany loc for bitget
    let sp = util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)
    let spu = 'exch/klines'

    if (eid === 'GET' || eid === 'GEF') {
      sp = 'ge'
      spu = 'exch/newklines'
    }

    return Apis[sp]
      .get(spu, {
        params: {
          token: $store.state.sys.token,
          eid,
          symbol,
          interval: resolution,
          startTime: from,
          endTime: to
        }
      })
      .then(response => {
        if (response.data.err) {
          return []
          // if (!count) {
          //   count = 0
          // }
          // console.log('error:', count, JSON.stringify(response.data))
          // if (count > 2) { // 3 times
          //   return []
          // }
          // return this.getBars(bartype, symbolInfo, resolution, from, to, first, limit, count + 1)
          // return Promise.reject('Попробуйте другой таймфрейм')
        } else {
          const bars = response.data
          // console.log('bars recieved', eid, bars.length)
          // if (bars && bars.length > 0) {
          //   console.log('first bar', bars[0])
          //   console.log('last bar', bars[bars.length - 1])
          // console.log('all bars', JSON.stringify(bars))
          // }
          if (first) {
            const lastBar1 = bars[bars.length - 1]
            history[symbolInfo.name] = { lastBar: lastBar1 }
            if (bartype === 'bot') {
              this.botLastBar[symb12] = lastBar1
            } else if (bartype === 'term') {
              this.lastBarBySymbol[symb12] = lastBar1
            } else if (bartype === 'grid') {
              this.gridLastBar[symb12] = lastBar1
              this.lastBarBySymbol[symb12] = lastBar1
            }
            // console.log('history last bar:', symb12, lastBar1)
          }
          return bars
        }
      })
      .catch(err => {
        console.warn('historyProvider.getBars failed:', eid, symbol, err && err.message ? err.message : err)
        return []
      })
  },

  historyDepth: (resolution, resolutionBack, intervalBack) => {
    if (resolution < 250) {
      let days = (600 / (1440 / resolution)).toFixed(0)
      if (days < 1) {
        days = 1
      }
      // console.log('days:', days)
      return { resolutionBack: 'D', intervalBack: days }
    }
  }
}
